module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-03-jp.ba2a612d710592b3af893a33bad452e1.png";